import { render } from "./ReportDispenserSummary.vue?vue&type=template&id=64472ec2&scoped=true"
import script from "./ReportDispenserSummary.vue?vue&type=script&lang=js"
export * from "./ReportDispenserSummary.vue?vue&type=script&lang=js"

import "./ReportDispenserSummary.vue?vue&type=style&index=0&id=64472ec2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64472ec2"]])

export default __exports__